import { render, staticRenderFns } from "./ProtestedTax.vue?vue&type=template&id=630561af&"
import script from "./ProtestedTax.vue?vue&type=script&lang=js&"
export * from "./ProtestedTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports